import axios from "axios";
import mapXCandidateApi from "api/candidateApi";
import {SICandidate} from "api/candidateApi/types";
import {TAppDispatch, TRootState} from "types";
import {
	rejectedAdditionalProfileResultsSelector,
	RejectedAdditionalProfilesPaginationInfoSelector,
} from "store/additional-profiles/additionalProfilesSelectors";
import {
	setAPMoreRejectedProfilesResult,
	setAPRejectedProfilesResult,
} from "store/additional-profiles/additionalProfilesActions";

/* eslint-disable  @typescript-eslint/no-explicit-any */
const cancelTokens = {} as any;

export const removeCandidateFromRejectedList =
	(candidateId: number) => (dispatch: TAppDispatch, getState: () => TRootState) => {
		const state = getState();
		const results = rejectedAdditionalProfileResultsSelector(state);
		const pagination = RejectedAdditionalProfilesPaginationInfoSelector(state);

		const rejectedData = {
			pagination: {
				...pagination,
				count: pagination.count - 1,
			},
			results: results.filter((item: SICandidate) => item.id !== candidateId),
		};

		dispatch(setAPRejectedProfilesResult(rejectedData));
	};

export const getAPRejectedProfilesByProjectId =
	(projectId: number, page = 1) =>
	async (dispatch: TAppDispatch) => {
		const requestKey = `GET_REJECTED_PROFILES_${projectId}`;

		if (requestKey in cancelTokens) {
			cancelTokens[requestKey].cancel("Operation canceled due to new request.");
		}

		cancelTokens[requestKey] = axios.CancelToken.source();

		const config = {
			cancelToken: cancelTokens[requestKey].token,
		};

		let response;

		try {
			// const query = `?rejected_candidates_project_id=${projectId}&page=${page}`;
			const payload = {
				filters: {rejected_candidates_project_id: projectId},
				pagination: {page},
			};

			response = await mapXCandidateApi.getCandidatesByFilter(payload, config);

			if (response?.status === 200 && response?.data) {
				if (page === 1) {
					dispatch(setAPRejectedProfilesResult(response.data));
				} else {
					dispatch(setAPMoreRejectedProfilesResult(response.data));
				}

				if (response.data.results.length > 0) {
					return response.data.results;
				} else return [];
			}

			return "cancelled";
		} catch (e) {
			console.log(`Error from getting rejected Profiles: ${e}`);

			return "cancelled";
		}
	};
